import React from "react";
import * as Style from "./styles/modal";

function Modal({ children, show, close, customWidth }) {
  return (
    <div>
      {show ? (
        <Style.Modal onClick={close} >
          <Style.ModalContent onClick={(e) => e.stopPropagation()} style={customWidth ?{maxWidth:'38rem'} : {}}>
            {children}
          </Style.ModalContent>
        </Style.Modal>
      ) : null}
    </div>
  );
}

export default Modal;
